export const OpenIdConfig = {
  RedirectUri: process.env.REACT_APP_OPENID_REDIRECT_URI || "",
  ClientId: process.env.REACT_APP_OPENID_CLIENT_ID || "",
  AuthUrl: process.env.REACT_APP_OPENID_AUTH_URL || "",
  TokenUrl: process.env.REACT_APP_OPENID_TOKEN_URL || "",
  SecretId: process.env.REACT_APP_OPENID_SECRET_ID || "",
  UserInfoUrl: process.env.REACT_APP_OPENID_USER_INFO_URL || "",
};
